import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  CONFIDENTIAL_GET_REQUEST,
  CONFIDENTIAL_GET_SUCCESS,
  CONFIDENTIAL_GET_FAILURE,
  CONFIDENTIAL_GET_RESET,
  CONFIDENTIAL_LIST_REQUEST,
  CONFIDENTIAL_LIST_SUCCESS,
  CONFIDENTIAL_LIST_FAILURE,
  CONFIDENTIAL_LIST_RESET,
  CONFIDENTIAL_EDIT_REQUEST,
  CONFIDENTIAL_EDIT_SUCCESS,
  CONFIDENTIAL_EDIT_FAILURE,
  CONFIDENTIAL_EDIT_RESET,
  CONFIDENTIAL_CREATE_REQUEST,
  CONFIDENTIAL_CREATE_SUCCESS,
  CONFIDENTIAL_CREATE_FAILURE,
  CONFIDENTIAL_CREATE_RESET,
  CONFIDENTIAL_DEACTIVATE_REQUEST,
  CONFIDENTIAL_DEACTIVATE_SUCCESS,
  CONFIDENTIAL_DEACTIVATE_FAILURE,
  CONFIDENTIAL_DEACTIVATE_RESET,
  CONFIDENTIAL_EXPORT_REQUEST,
  CONFIDENTIAL_EXPORT_SUCCESS,
  CONFIDENTIAL_EXPORT_FAILURE,
  CONFIDENTIAL_EXPORT_RESET,
  CONFIDENTIAL_IMPORT_REQUEST,
  CONFIDENTIAL_IMPORT_SUCCESS,
  CONFIDENTIAL_IMPORT_FAILURE,
  CONFIDENTIAL_IMPORT_RESET,
} from './../../constants'

export function createConfidential(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-confidentials`,
      method: 'POST',
      types: [
        CONFIDENTIAL_CREATE_REQUEST,
        CONFIDENTIAL_CREATE_SUCCESS,
        CONFIDENTIAL_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getConfidential(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-confidentials`,
      method: 'GET',
      types: [
        CONFIDENTIAL_LIST_REQUEST,
        CONFIDENTIAL_LIST_SUCCESS,
        CONFIDENTIAL_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getConfidentialByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-confidentials/${id}`,
      method: 'GET',
      types: [
        CONFIDENTIAL_GET_REQUEST,
        CONFIDENTIAL_GET_SUCCESS,
        CONFIDENTIAL_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function deactivateConfidential(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-confidentials/${id}/delete`,
      method: 'PUT',
      types: [
        CONFIDENTIAL_DEACTIVATE_REQUEST,
        CONFIDENTIAL_DEACTIVATE_SUCCESS,
        CONFIDENTIAL_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editConfidential(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-confidentials/${id}`,
      method: 'PUT',
      types: [
        CONFIDENTIAL_EDIT_REQUEST,
        CONFIDENTIAL_EDIT_SUCCESS,
        CONFIDENTIAL_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function exportConfidential(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-confidentials/exports`,
      method: 'GET',
      types: [
        CONFIDENTIAL_EXPORT_REQUEST,
        CONFIDENTIAL_EXPORT_SUCCESS,
        CONFIDENTIAL_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function importConfidential(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-confidentials/imports`,
      method: 'POST',
      types: [
        CONFIDENTIAL_IMPORT_REQUEST,
        CONFIDENTIAL_IMPORT_SUCCESS,
        CONFIDENTIAL_IMPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: payload,
    },
  }
}

export function resetListConfidential() {
  return {
    type: CONFIDENTIAL_LIST_RESET,
  }
}
export function resetCreateConfidential() {
  return {
    type: CONFIDENTIAL_CREATE_RESET,
  }
}
export function resetEditConfidential() {
  return {
    type: CONFIDENTIAL_EDIT_RESET,
  }
}
export function resetGetConfidential() {
  return {
    type: CONFIDENTIAL_GET_RESET,
  }
}
export function resetDeactivateConfidential() {
  return {
    type: CONFIDENTIAL_DEACTIVATE_RESET,
  }
}
export function resetExportConfidential() {
  return {
    type: CONFIDENTIAL_EXPORT_RESET,
  }
}

export function resetImportConfidential() {
  return {
    type: CONFIDENTIAL_IMPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/confidential/confidential-action.js